import { gql } from '__generated__';

export default gql(`
  query GetAddress($country: String!, $zip_code: String!, $house_number: String) {
    getAddress(country: $country, zip_code: $zip_code, house_number: $house_number) {
      id
      country
      zip_code
      house_number
      street
      city
      valid
    }
  }
`);

